export default {
    common: {
        title: "Modifier l'image",
        cancel: "Annuler",
        save: "Enregistrer",
        crop: "Récolte",
        adjustments: "Ajustements",
        filters: "Filtres",
        frames: "Montures",
        overlays: "Superpositions",
        text: "Texte",
        stickers: "Autocollants",
        brush: "Brosse",
        ai: "Créer une image à l'aide de l'IA",
        reset: "Réinitialiser",
        comingSoon: 'Bientôt Disponible...',
    },
};
